import { DEFAULT_ERROR_MESSAGE } from '@app/common/utils/constants';

const CATEGORY_LIST = [
    {
        id: 'CAT 1',
        label: 'CAT 1',
    },
    {
        id: 'CAT 2',
        label: 'CAT 2',
    },
    {
        id: 'HE/M',
        label: 'HE/M',
    },
];

const PRIORITY_LIST = [
    {
        id: 'A',
        label: 'A',
    },
    {
        id: 'B',
        label: 'B',
    },
    {
        id: 'C',
        label: 'C',
    },
];

const STATUS_LIST = [
    {
        id: 'Awaiting Response',
        label: 'Awaiting Response',
    },
    {
        id: 'Under Review',
        label: 'Under Review',
    },
    {
        id: 'In Process',
        label: 'In Proces',
    },
    {
        id: 'Disagree / No Plans',
        label: 'Disagree / No Plans',
    },
    {
        id: 'Completed Notified',
        label: 'Completed Notified',
    },
    {
        id: 'Completed Verified',
        label: 'Completed Verified',
    },
    {
        id: 'No Longer Valid',
        label: 'No Longer Valid',
    },
    {
        id: 'Deferred By Account Manager',
        label: 'Deferred By Account Manager',
    },
];

const COST_ESTIMATE_LIST = [
    {
        id: 'Not Known',
        label: 'Not Known',
    },
    {
        id: 'Revenue Only',
        label: 'Revenue Only',
    },
    {
        id: '10 - 50,000 AED',
        label: '10 - 50,000 AED',
    },
    {
        id: '50,001 - 100,000 AED',
        label: '50,001 - 100,000 AED',
    },
    {
        id: '100,001 - 250,000 AED',
        label: '100,001 - 250,000 AED',
    },
    {
        id: '251,001 - 500,000 AED',
        label: '251,001 - 500,000 AED',
    },
    {
        id: '500,001 - 1,000,000 AED',
        label: '500,001 - 1,000,000 AED',
    },
    {
        id: '1,000,001 - 1,500,000 AED',
        label: '1,000,001 - 1,500,000 AED',
    },
    {
        id: '1,500,001 - 2,500,000 AED',
        label: '1,500,001 - 2,500,000 AED',
    },
    {
        id: '2,500,001 - 5,000,000 AED',
        label: '2,500,001 - 5,000,000 AED',
    },
    {
        id: '5,000,001 - 10,000,000 AED',
        label: '5,000,001 - 10,000,000 AED',
    },
    {
        id: '>10,000,000 AED',
        label: '>10,000,000 AED',
    },
];

const saveRiskImprovement = function (parent, question, riskImprovement) {
    let msg;
    let updated = false;
    if (!riskImprovement.id) {
        msg = parent.$parent.$t('Risk Improvement saved successfully');
    } else {
        updated = true;
        msg = parent.$parent.$t('Risk Improvement updated successfully');
    }
    riskImprovement.create({
        beforesend: () => {
            parent.loading = true;
        },
        complete: () => {
            parent.loading = false;
        },
        success: async (op, response) => {
            // this.$emit('save', response.data);
            if (!updated) {
                question?.data?.risk_improvements?.push(response.data);
            }
            parent.$notify.success({
                title: parent.$parent.$t('Success'),
                message: msg,
            });
        },
        failure: (op, response) => {
            parent.$notify.error({
                title: parent.$t('Error'),
                message:
                    response && response.meta
                        ? response.meta.display_message
                        : parent.$t(DEFAULT_ERROR_MESSAGE),
            });
        },
    });
};

export {
    CATEGORY_LIST,
    PRIORITY_LIST,
    STATUS_LIST,
    COST_ESTIMATE_LIST,
    saveRiskImprovement,
    // getFieldProperty,
};
